import Login from "../views/login/Login";
import LoginCallback from "../views/login/LoginCallback";
import Logout from "../views/login/Logout";
import LogoutCallback from "../views/login/LogoutCallback";
import OtpPage from "../views/login/otp-page";
import BeforeEnterAppPage from "../views/login/before-enter-app-page";

export default [
  {
    path: "/login",
    name: "login",
    component: Login
  },
  {
    path: "/loginCallback",
    name: "loginCallback",
    component: LoginCallback
  },
  {
    path: "/logout",
    name: "logout",
    component: Logout
  },
  {
    path: "/logoutCallback",
    name: "logoutCallback",
    component: LogoutCallback
  },
  {
    path: "/otp",
    name: "otp",
    component: OtpPage
  },
  {
    path: "/beforeEnterApp",
    name: "beforeEnterApp",
    component: BeforeEnterAppPage
  },
];



// WEBPACK FOOTER //
// ./src/router/login.js